import type { TranslationInterface } from '.';

export const LuxembourgishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Schreift eng Noriicht...',
  your_issue_has_been_resolved: 'Äert Problem gouf geléist!',
  new_conversation: 'Nei Konversatioun',
  welcome_screen_title: 'Wëllkomm bei eisem Support-Chat',
  welcome_screen_description:
    'Mir sinn hei fir ze hëllefen! Start eng Konversatioun a mir äntweren Iech esou séier wéi méiglech.',
  your_name_placeholder: 'Ären Numm',
  your_email_placeholder: 'Är E-Mail-Adress',
  start_chat_button: 'Mat dem Support schwätzen',
  start_chat_button_loading: 'Verbindung...',
  i_need_more_help: 'Ech brauch méi Hëllef',
  this_was_helpful: 'Dat war hëllefräich',
  optional: 'Fakultativ',
  no_conversations_yet: 'Nach keng Konversatiounen',
  back_to_conversations: 'Zréck zu de Konversatiounen',
  closed_conversations: 'Zougemaachte Konversatiounen',
  csat_title: 'Wéi war Är Konversatioun?',
  csat_submitted_title: 'Dir hutt d’Konversatioun bewäert als',
  csat_feedback_placeholder: 'Sot eis méi... (fakultativ)',
  follow_up_placeholder: 'Nofroen…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Schwebend',
  companion_layout_sidebar: 'Säitleeschte',
  companion_layout_fullscreen: 'Vollbild',
  companion_close: 'Zoumaachen',
  companion_history: 'Gespréichsverlaf',
  companion_expand_chat: 'Chat ausklappen',
  companion_sidebar_dock_label: 'Andocken',
  companion_sidebar_side_label: 'Säit',
  companion_sidebar_left: 'Lénks',
  companion_sidebar_right: 'Riets',
  companion_resize_chat: 'Chatgréisst änneren',
  scroll_to_bottom: 'No ënne scrollen',
  thinking: 'Ech denken no…',
  running: 'Gëtt ausgefouert…',
  steps: 'Schrëtt',
  step_arguments: 'Argumenter',
  step_result: 'Resultat',
  attach_files:
    'Biller, Videoen, PDFen oder Tabelle bäifügen (maximal Gréisst 25 MB)',
  mark_page_active:
    'Klickt op eppes op der Säit, fir et ze markéieren — Esc fir ofzebriechen',
  mark_page: 'Markéiert eppes op der Säit, fir doriwwer ze froen',
  stop_response: 'Äntwert stoppen',
  copy_reply: 'Äntwert kopéieren',
  mentions_empty: 'Keng Treffer',
  copied: 'Kopéiert',
  send_message: 'Noriicht schécken',
  upload_failed: 'Eroplueden net gelongen: {error}',
  remove_attachment: 'Unhang ewechhuelen',
  json_no_items: 'Keng Elementer',
  json_no_data: 'Keng Donnéeën',
  json_no_chart_data: "Keng Donnéeë fir d'Diagramm",
  json_unsupported: 'Net ënnerstëtzt: {type}',
  json_see_less: 'Manner weisen',
  json_phone_agent: 'Telefonsagent',
  json_phone_agent_test: 'Am Web testen',
  page_context_remove: 'Säitekontext ewechhuelen',
  json_see_more: '{count} weider weisen',
  queued_label: '{count} An der Waardeschlaang',
  remove_queued_message: 'Noriicht aus der Waardeschlaang ewechhuelen',
  send_queued_now: 'Noriichten aus der Waardeschlaang elo schécken',
  turn_failed_message: "Eppes ass schifgaangen an d'Äntwert ass net ukomm.",
  turn_failed_retry: 'Nach eng Kéier probéieren',
  page_mark_hint: 'Klickt op eppes, fir et ze markéieren',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Këscht',
  page_mark_shape_circle: 'Krees',
  page_mark_shape_arrow: 'Pfeil',
  page_mark_shape_bracket: 'Klammer',
  page_mark_shape_underline: 'Ënnersträichen',
  page_mark_shape_highlight: 'Markéieren',
  page_mark_shape_strike_through: 'Duerchsträichen',
  page_mark_shape_crossed_off: 'Duerchkräizen',
  page_mark_shape_aria: 'Form vun der Markéierung: {shape}',
  page_mark_note_placeholder: 'Notiz derbäisetzen… (Enter fir bäizefügen)',
  page_mark_attach: 'Markéierung bäifügen',
  page_mark_remove: '{label} ewechhuelen',
  page_mark_region: 'Markéierte Beräich',
  page_mark_default_message: 'Wat ass dat?',
  file_rejected:
    'De Fichierstyp gëtt net ënnerstëtzt oder de Fichier ass ze grouss.',
  dictate: 'Diktéieren',
  stop_dictation: 'Diktat ophalen',
  dictation_mic_blocked: 'Erlaabt den Zougang zum Mikro fir ze diktéieren',
  dictation_unavailable: 'Diktéieren ass am Moment net verfügbar',
  questions_back: 'Zréck',
  questions_next: 'Weider',
  questions_send: 'Schécken',
  questions_type_answer: 'Ech schreiwen et selwer',
  questions_answer_placeholder: 'Schreift Är Äntwert…',
  close_conversation_title: 'Konversatioun zoumaachen',
  close_conversation_description:
    'Wëllt Dir dës Konversatioun wierklech zoumaachen?',
  close_conversation_cancel: 'Nee',
  close_conversation_confirm: 'Jo',
  dialog_close: 'Zoumaachen',
  zoom_in: 'Erazoomen',
  zoom_out: 'Erauszoomen',
  reset_zoom: 'Zoom zrécksetzen',
  support_chat_aria_label: 'Support-Chat',
};
